<template>
  <div>
    <Card v-show = "!getFormOpened" class = "widget-height-md ivu-card-custom" shadow>
      <div slot = "title" class = "with-icon">
        <h4>Contact Form Settings</h4>
        <Icon v-show = "userRole=='admin'" type = "ios-add-circle-outline" color = "white" size = "24"
              @click.native = "$refs.formForm.openForm('Create New Form','add', allQuestions)" />
      </div>
      <div class = "widget-data full-height">
        <Table ref = "dataTable" :columns = "dataColumns" :data = "items"
               class = "full-height show-borders initial-height" stripe border shadow></Table>
        <Page v-show = "showPager" :total = "dataCount" :page-size = "pageSize"
              show-total show-sizer :page-size-opts = "pageSizer" transfer
              @on-change = "changeSelectedPage" @on-page-size-change = "changePageSize">
        </Page>
        <Spin size = "large" fix v-if = "spinformShow"></Spin>
      </div>
      <formForm ref = "formForm" @addForm = "add_Form" @viewForm = "view_Form" @updateForm = "update_Form"></formForm>
      <Modal v-model = "confirmDelete" title = "CONFIRMATION" @on-ok = "remove_Form(currentDeleteIndex)"
             ok-text = "Continue" class-name = "vertical-center-modal card-modal" :width = "480">
        <div class = "confirmation-body">
          <p>
            <Icon type = "md-help-circle" size = "24" color = "#f90" />
            <span>{{confirmDeleteMessage}}</span></p>
          <p class = "submessage">*all associated data will be erased</p>
        </div>
        <div slot = "footer">
          <Button size = "large" @click = "confirmDelete=false">Cancel</Button>
          <Button size = "large" @click = "remove_Form(currentDeleteIndex);confirmDelete=false"
                  class = "submit" type = "error">Delete
          </Button>
        </div>
      </Modal>
    </Card>
    <div v-show = "getFormOpened">
      <Card class = "widget-height-md ivu-card-custom" shadow>
        <div slot = "title" class="with-icon p-3">
          <h4>
            <table style = "width:100%; padding:5px">
              <tr>
                <td align = "left" valign = "bottom" style = "width: 150px;">
                  <b><u><label style = "width: 100%;">Contact Form :</label></u></b>
                </td>
                <td align = "left" valign = "bottom">
                  <Label v-show = "!showFormTitle" :for = "form.title" @click = "toggleFormName">
                    {{this.form.title}}
                  </Label>
                  <input v-show = "showFormTitle" v-model = "form.title" type = "text"
                         class = "ivu-input ivu-input-default" placeholder = "Form Name"
                         style = "width:50%; font-size: 14px" />
                </td>
              </tr>
              <tr>
                <td colspan = "2">&nbsp;</td>
                <td align = "right" valign = "bottom" style = "width: 150px;">
                  <Label :for = "form.isActive">Active</Label>
                  <i-switch v-model = "form.isActive"></i-switch>
                </td>
              </tr>
              <tr>
                <td align = "left" valign = "top" style = "width: 100px;">
                  <b><u><label>Description :</label></u></b>
                </td>
                <td align = "left" valign = "top">
                  <Label v-show = "!showFormDesc" :for = "form.desc"
                         @click = "toggleFormDesc">{{this.form.desc}}</Label>
                  <Input v-show = "showFormDesc"
                         v-model = "form.desc" type = "textarea" :autosize = "{minRows: 2,maxRows: 10}"
                         placeholder = "Form Description" style = "width:50%" />
                </td>
                <td></td>
              </tr>
              <tr>
                <td colspan = "3">&nbsp;</td>
              </tr>
              <tr>
                <td colspan = "3" align = "left" valign = "bottom">
                  <Button v-show = "showAddress==false" class = "btnAdds" icon = "md-add" size = "small"
                          @click = "addAddress">
                    Address
                  </Button>
                  <Button v-show = "showCity==false" class = "btnAdds" icon = "md-add" size = "small"
                          @click = "addCity">
                    City
                  </Button>
                  <Button v-show = "!showPhone" class = "btnAdds" icon = "md-add" size = "small" @click = "addPhone">
                    Phone
                  </Button>
                  <Button v-show = "!showJobTitle" class = "btnAdds" icon = "md-add" size = "small"
                          @click = "addJobTitle">
                    Job Title
                  </Button>
                  <Button v-show = "!showRating" class = "btnAdds" icon = "md-add" size = "small" @click = "addRating">
                    Lead Rating
                  </Button>
                  <Button class = "btnAdds" icon = "md-add" size = "small" @click = "addOther">
                  </Button>
                </td>
              </tr>
            </table>
          </h4>
        </div>
        <div class = "widget-data full-height">
          <Table :data = "formData" :columns = "formDataColumns" class = "full-height show-borders initial-height"
                 stripe>
          </Table>
          <Spin size = "large" fix v-show = "spinformShow"></Spin>
        </div>
        <Modal v-model = "formConfirmDelete" title = "CONFIRMATION" @on-ok = "remove_Question(formDeleteIndex)"
               ok-text = "Continue" class-name = "vertical-center-modal card-modal" :width = "480">
          <div class = "confirmation-body">
            <p>
              <Icon type = "md-help-circle" size = "24" color = "#f90" />
              <span>{{formConfirmDeleteMessage}}</span></p>
            <p class = "submessage">*all associated data will be erased</p>
          </div>
          <div slot = "footer">
            <Button size = "large" @click = "formConfirmDelete=false">Cancel</Button>
            <Button size = "large" @click = "remove_Question(formDeleteIndex);formConfirmDelete=false" class = "submit"
                    type = "error">Delete
            </Button>
          </div>
        </Modal>
      </Card>
      <div style = "right: 0; float: right; margin: 10px;">
        <Button size = "large" @click = "goBackToForms" type = "default" style = "margin-right: 10px" class="btn btn-outline-secondary btn-sm">Cancel & Back to Forms</Button>
        <Button size = "large" @click = "goBack" type = "default" style = "margin-right: 10px" class="btn btn-outline-secondary btn-sm">Cancel & Back to Administration</Button>
        <Button size = "large" v-show = "addedForm" @click = "saveNewForm" class="submit btn btn-success btn-sm" type = "success">Create</Button>
        <Button size = "large" v-show = "!addedForm" @click = "saveUpdatedForm" class="submit btn btn-success btn-sm" type = "warning">Update</Button>
      </div>
      <choicesForm ref = "choicesForm"></choicesForm>
    </div>
  </div>
</template>
<script>
  import {
    addForm,
    deleteForm,
    getForms,
    getSubFormByIds,
    updateForm,
    getLeadFormByEvent
  } from '../../services/Forms.service'
  import formForm from './_formForm'
  import choicesForm from './_choicesForm'
  import {mapActions, mapGetters} from 'vuex'
  import {bus} from '../../main'

  export default {
    components: {
      formForm, choicesForm
    },
    props: ['forms'],
    data() {
      return {
        activeLink: '',
        userRole: localStorage.getItem('role'),
        formOpened: false,
        subFormId: null,
        formId: null,
        formName: null,
        eventName: localStorage.getItem('selected_event'),
        companyName: this.getCompanyDetail,
        spinformShow: true,
        confirmDelete: false,
        confirmDeleteMessage: '',
        currentDeleteIndex: null,
        typeList: [
          {type: 'text', inputType: 'text', title: 'Free Text', iconType: 'ios-menu-outline'},
          {
            type: 'textArea', inputType: 'textArea', title: 'Free Text field (multiple lines)',
            iconType: 'ios-menu-outline'
          },
          {type: 'text', inputType: 'country', title: 'Country', iconType: 'ios-flag-outline'},
          {type: 'text', inputType: 'date', title: 'Date', iconType: 'ios-calendar-outline'},
          {type: 'text', inputType: 'email', title: 'Email', iconType: 'ios-mail-outline'},
          {type: 'text', inputType: 'phoneNumber', title: 'Phone', iconType: 'ios-call-outline'},
          {type: 'leadRating', inputType: 'leadRating', title: 'Lead Rating', iconType: 'ios-star-outline'},
          {type: 'checkbox', inputType: 'multiChoice', title: 'Multiple Choice', iconType: 'ios-checkbox-outline'},
          {type: 'radioList', inputType: 'singleChoice', title: 'Single Choice', iconType: 'ios-radio-button-on'},
          // Hidden options - Photo and Scan
          // {type: 'photo', inputType: 'photo', title: 'Photo', iconType: 'ios-image-outline'},
          // {type: 'QRCode', inputType: 'scan', title: 'Scan', iconType: 'ios-qr-scanner'},
        ],
        dataCount: 0,
        pageSizer: [25, 50, 100],
        pageSize: 25,
        historyData: [],
        showPager: false,
        dataColumns: [
          {
            title: 'Active',
            key: 'isActive',
            align: 'left',
            minWidth: 100,
            maxWidth: 80,
            visible: false,
            className: 'paddingIndent table-cell-active-custom',
            sortable: true,
            render: (h, params) => {
              if (params.row.isActive == true) {
                return h('Icon', {
                  props: {
                    type: 'ios-checkmark',
                    size: '24'
                  },
                  style: {
                    color: '#fff',
                    backgroundColor: '#35bc44',
                    borderRadius: '5px',
                    cursor: this.userRole == 'admin' ? 'pointer' : 'not-allowed',
                  },
                  on: {
                    click: () => {
                      if (this.userRole == 'admin') {
                        this.spinformShow = true;
                        params.row.isActive = false;
                        const data = Object.assign({}, params.row);
                        delete data['_index'];
                        delete data['_rowKey'];
                        updateForm(params.row.formId, data).then(response => {
                          this.$emit('updateForm', params.row.formId, data);
                          this.getFormsData();
                        }).catch(error => {
                          this.$Message.error('Failed updating form ' + error);
                        });
                      }
                    }
                  }
                })
              } else {
                return h('Icon', {
                  props: {
                    type: 'md-close',
                    size: '24'
                  },
                  style: {
                    color: '#fff',
                    backgroundColor: '#6f6f70',
                    borderRadius: '5px',
                    cursor: this.userRole == 'admin' ? 'pointer' : 'not-allowed',
                  },
                  on: {
                    click: () => {
                      if (this.userRole == 'admin') {
                        this.spinformShow = true;
                        params.row.isActive = true;
                        const data = Object.assign({}, params.row);
                        delete data['_index'];
                        delete data['_rowKey'];
                        updateForm(params.row.formId, data).then(response => {
                          this.$emit('updateForm', params.row.formId, data);
                          this.getFormsData();
                        }).catch(error => {
                          this.$Message.error('Failed updating form ' + error);
                        })
                      }
                    }
                  }
                })
              }
            }
          },
          {
            title: 'Name',
            key: 'title',
            align: 'left',
            className: 'paddingIndent',
            sortable: true,
            render: (h, params) => {
              return h('div', {
                attrs: {
                  title: params.row.title,
                }
              }, params.row.title);
            }
          },
          {
            title: 'Description',
            key: 'desc',
            align: 'left',
            className: 'paddingIndent',
            sortable: true,
            render: (h, params) => {
              return h('div', {
                attrs: {
                  title: params.row.desc,
                }
              }, params.row.desc);
            }
          },
          {
            title: 'Summary',
            key: 'questions',
            align: 'left',
            className: 'paddingIndent',
            sortable: true,
            render: (h, params) => {
              let title = '';
              if (params.row.questions) {
                let x = params.row.questions
                  .map((data, i) => {
                    if (data.title.toLowerCase() == 'id') {
                      data.order = -1;
                      data.canDelete = false;
                      data.status = false;
                    }
                    if (data.fieldCode.indexOf('barcode') > -1 || data.fieldCode.indexOf('codebarre') > -1
                      || data.title.indexOf('barcode') > -1 || data.title.indexOf('codebarre') > -1) {
                      data.order = -1;
                    }
                    return data;
                  }, [])
                  .filter(a => a.status !== false)
                  .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));

                x = x.map((data, i) => {
                  title += data.title.toUpperCase() + '\n';
                  if (i < x.length - 1) {
                    let ret = h('span', data.title + ',');
                    return ret;
                  } else {
                    let ret = h('span', data.title);
                    return ret;
                  }
                  //return data;
                });

                let result = h('div', {
                  attrs: {
                    title: title
                  }
                }, x);
                return result;
              } else {
                let result = h('span', {attrs: {title: 'No data'}}, 'No data.');
                return result;
              }
            },
          },
          {
            title: 'Action',
            key: 'action',
            align: 'left',
            minWidth: 100,
            maxWidth: 130,
            className: 'paddingIndent',
            render: (h, params) => {
              let viewIcon = h('Icon', {
                props: {
                  type: 'ios-eye-outline',
                  size: '24'
                },
                on: {
                  click: () => {
                    let newData = this.items[params.row._index];
                    newData = this.setChoiceStatus(newData, 'view');
                    this.$refs.formForm.openForm('Lead Form', 'view');
                    this.$refs.formForm.setFormValue(newData, params.index);
                  }
                }
              });
              let editIcon = h('Icon', {
                props: {
                  type: 'ios-create-outline',
                  size: '24'
                },
                on: {
                  click: () => {
                    this.formDataList = this.editForm(params.row);
                  }
                }
              });
              let deleteIcon = h('Icon', {
                props: {
                  type: 'ios-close-circle-outline',
                  color: '#9b3035',
                  size: '24'
                },
                on: {
                  click: () => {
                    this.confirmDeleteMessage = `Are you sure you want to delete form "${params.row.title}"?`
                    this.confirmDelete = true;
                    this.currentDeleteIndex = params.index;
                  }
                }
              })

              if (this.userRole == 'admin') {
                let icons = [viewIcon, editIcon, deleteIcon];
                return h('div', [icons]);
              } else {
                let icons = [viewIcon, editIcon];
                return h('div', [icons]);
              }
            }
          }
        ],
        items: [],
        formDataColumns: [
          {
            title: 'Order',
            key: 'order',
            isEditable: true,
            align: 'left',
            minWidth: 90,
            maxWidth: 90,
            className: 'paddingIndent',
            sortable: false,
            render: (h, params) => {
              let disabled = false;
              if (params.row.headerTag === 'barcode' || params.row.headerTag === 'codebarre') {
                disabled = true;
              }
              return h('Input',
                {
                  attrs: {
                    value: params.row.order,
                    disabled: disabled
                  },
                  on: {
                    'on-blur': (e) => {
                      const self = this;
                      if (e.target.value != 0) {
                        let row = self.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                        row.order = e.target.value;
                        self.formDataList
                          .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));
                      }
                      // self.formDataList
                      //   .sort((a, b) => (a.canDelete > b.canDelete) ? 1 : ((b.canDelete > a.canDelete) ? -1 : 0));
                    },
                    'on-change': (e) => {
                      if (e.target.value == '0') {
                        const self = this;
                        let row = self.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                        row.order = e.target.value;
                        e.target.value = '';
                        row.order = '';
                        self.$Message.warning({
                          content: 'Zero is reserved for ' + self.formDataList[0].label,
                          duration: 3
                        });
                      }
                    }
                  }
                },
                [h('Icon', {
                  props: {
                    type: 'ios-menu-outline',
                    size: 'small',
                  },
                  style: {
                    marginRight: '5px'
                  }
                }), params.row.order]
              );
            }
          },
          {
            title: 'Label',
            key: 'label',
            align: 'left',
            minWidth: 100,
            className: 'paddingIndent',
            sortable: false,
            render: (h, params) => {
              let disabled = false;
              // if (params.index == 0) disabled = true;
              return h('Input', {
                attrs: {
                  value: params.row.label,
                  disabled: disabled,
                },
                style: {
                  "border": "0",
                  "border-bottom": "1px solid black"
                },
                on: {
                  'on-blur': (e) => {
                    let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                    row.label = e.target.value;
                    //row.headerTag = e.target.value.replace(/\s+/g, '').toLowerCase();
                  }
                }
              });
            }
          },
          {
            title: 'Field Code',
            key: 'fieldCode',
            align: 'left',
            className: 'paddingIndent',
            minWidth: 120,
            maxWidth: 120,
            sortable: false,
            render: (h, params) => {
              let disabled = false;
              const self = this;
              // if (params.index == 0) disabled = true;
              return h('AutoComplete', {
                props: {
                  value: params.row.fieldCode == null ? '' : params.row.fieldCode,
                  disabled: disabled,
                  data: self.fieldCodes,
                  transfer: true
                },
                on: {
                  'on-blur': (e) => {
                    let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                    row.fieldCode = e.target.value;
                  },
                  'on-select': (e) => {
                    let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                    row.fieldCode = e;
                  }
                }
              });
            }
          },
          {
            title: 'Answer Type',
            key: 'type',
            align: 'left',
            className: 'paddingIndent',
            sortable: false,
            minWidth: 150,
            maxWidth: 150,
            render: (h, params) => {
              const self = this;
              let disabled = false;
              if (params.row.headerTag === 'barcode' || params.row.headerTag === 'codebarre') disabled = true;
              let questionTitle = this.getQuestionTitle(params.row);
              let options = this.typeList.map((data) => {
                let questionIcon = this.getQuestionIcon(data);
                let ret = h('Option', {
                  props: {
                    'key': data.inputType,
                    'label': data.title,
                    'value': data.inputType,
                  },
                  style: {
                    backgroundColor: '#c6e5fd'
                  }
                }, [
                  h('Icon', {
                    props: {
                      type: questionIcon, size: 'small'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }), data.title
                ]);
                return ret;
              }, []);

              let elem = h('Select',
                {
                  attrs: {
                    class: 'selectInput',
                    disabled: disabled
                  },
                  props: {
                    value: params.row.inputType,
                    transfer: true,
                    filterable: true,
                  },
                  style: {
                    backgroundColor: '#c6e5fd'
                  },
                  on: {
                    'on-change': (val) => {
                      let status = false;
                      let question = self.formDataList[params.index];
                      if (question) {
                        question.status = true;
                        question.canAddChoices = false;
                      }
                      if (val === 'text') {
                        question.type = 'text';
                        question.inputType = 'text';
                      }
                      if (val === 'photo') {
                        question.type = 'photo';
                        question.inputType = 'photo';
                        // question.canAddChoices = false;
                      }
                      if (val === 'country') {
                        question.type = 'text';
                        question.inputType = 'country';
                        // question.choices = null;
                      }
                      if (val === 'date') {
                        question.type = 'text';
                        question.inputType = 'date';
                        // question.choices = null;
                      }
                      if (val === 'email') {
                        question.type = 'text';
                        question.inputType = 'email';
                        // question.choices = null;
                      }
                      if (val === 'phoneNumber') {
                        question.type = 'text';
                        question.inputType = 'phoneNumber';
                        // question.choices = null;
                      }
                      if (val === 'textArea') {
                        question.type = 'textArea';
                        question.inputType = 'textArea';
                        // question.choices = null;
                      }
                      if (val === 'leadRating') {
                        question.fieldCode = 'leadRating';
                        question.type = 'leadRating';
                        question.inputType = 'leadRating';
                        question.choices = [];
                        question.choices.push({
                          actionOnSync: '',
                          choiceId: parseInt(question.questionId.toString() + "0"),
                          label: 'HOT',
                          order: 0,
                          questionId: question.questionId,
                          status: status
                        }, {
                          actionOnSync: '',
                          choiceId: parseInt(question.questionId.toString() + "1"),
                          label: 'WARM',
                          order: 1,
                          questionId: question.questionId,
                          status: status
                        }, {
                          actionOnSync: '',
                          choiceId: parseInt(question.questionId.toString() + "2"),
                          label: 'COLD',
                          order: 2,
                          questionId: question.questionId,
                          status: status
                        });
                      }
                      if (val === 'multiChoice') {
                        question.type = 'checkbox';
                        question.inputType = 'multiChoice';
                        question.canAddChoices = true;
                        self.$refs.choicesForm.openChoices();
                        self.$refs.choicesForm.setFormValue(self.formDataList, params.index);
                      }
                      if (val === 'singleChoice') {
                        question.type = 'radioList';
                        question.inputType = 'singleChoice';
                        question.canAddChoices = true;
                        self.$refs.choicesForm.openChoices();
                        self.$refs.choicesForm.setFormValue(self.formDataList, params.index);
                      }
                    }
                  }
                }, [options]);
              return elem;
            }
          },
          {
            title: 'Optional',
            key: 'optional',
            align: 'Center',
            minWidth: 80,
            maxWidth: 80,
            className: 'paddingIndent',
            sortable: false,
            render: (h, params) => {
              let isOptional = true;
              // if (params.index == 0) {
              //   isOptional = false;
              // }
              if (isOptional) {
                if (params.row.optional == true) {
                  return h('Icon', {
                    props: {
                      type: 'ios-checkmark'
                    },
                    style: {
                      fontSize: '20px',
                      fontWeight: '900',
                      color: '#fff',
                      backgroundColor: '#35bc44',
                      borderRadius: '5px'
                    },
                    on: {
                      click: (e) => {
                        let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                        row.optional = !row.optional;
                      }
                    }
                  })
                } else {
                  return h('Icon', {
                    props: {
                      type: 'md-close'
                    },
                    style: {
                      fontSize: '20px',
                      fontWeight: '900',
                      color: '#fff',
                      backgroundColor: '#6f6f70',
                      borderRadius: '5px'
                    },
                    on: {
                      click: (e) => {
                        let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                        row.optional = !row.optional;
                      }
                    }
                  })
                }
              }
            }
          },
          {
            title: 'Hide',
            key: 'hide',
            align: 'Center',
            minWidth: 80,
            maxWidth: 80,
            className: 'paddingIndent',
            sortable: false,
            render: (h, params) => {
              let disabled = false;
              if (params.row.headerTag) {
                if (params.row.headerTag.indexOf('barcode') > -1 || params.row.headerTag.indexOf('codebarre') > -1) {
                  disabled = true;
                  let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                  row.hide = true;
                  params.row.hide = true;
                }
              }
              let checked = params.row.hide;

              return h('Icon', {
                attrs: {
                  disabled: disabled
                },
                props: {
                  type: checked ? 'ios-checkmark' : 'md-close'
                },
                style: {
                  fontSize: '20px',
                  fontWeight: '900',
                  color: '#fff',
                  backgroundColor: checked ? '#35bc44' : '#6f6f70',
                  borderRadius: '5px'
                },
                on: {
                  click: (e) => {
                    if (!disabled) {
                      let row = this.formDataList.filter(a => a.questionId == params.row.questionId)[0];
                      row.hide = !row.hide;
                    }
                  }
                }
              })

            }
          },
          {
            title: 'Action',
            key: 'action',
            align: 'Center',
            minWidth: 80,
            maxWidth: 80,
            className: 'paddingIndent',
            render: (h, params) => {
              let disabled = false;
              if (params.index == 0) disabled = true;
              if (!disabled) {
                if (this.userRole == 'admin') {
                  if (params.row.canDelete) {
                    return h('div', [
                      h('Icon', {
                        attrs: {
                          disabled: disabled
                        },
                        props: {
                          type: 'ios-close-circle-outline',
                          color: '#9b3035'
                        },
                        style: {
                          marginRight: '5px',
                          fontSize: '25px',
                          fontWeight: '900'
                        },
                        on: {
                          click: () => {
                            this.formConfirmDeleteMessage = `Are you sure you want to delete "${params.row.label}"?`;
                            this.formConfirmDelete = true;
                            this.formDeleteIndex = params.index;
                          }
                        }
                      })
                    ]);
                  }
                }
              }
            }
          }
        ],
        formDataList: [{
          questionId: null,
          formId: null,
          allowOther: null,
          choices: null,
          fieldCode: null,
          inputType: null,
          order: null,
          label: null,
          type: null,
          hide: null,
          optional: null
        }],
        formDeleteIndex: null,
        formConfirmDelete: false,
        formConfirmDeleteMessage: '',
        form: {
          formId: null,
          title: null,
          desc: null,
          companyId: null,
          eventId: null,
          order: null,
          isLeadForm: null,
          isSurveyForm: null,
          isActive: null,
          questions: null
        },
        showFormTitle: false,
        showFormDesc: false,
        showAddress: false,
        showCity: false,
        showPhone: false,
        showJobTitle: false,
        showRating: false,
        addedForm: false,
        allQuestions: [],
        fieldCodes: [
          'barcode',
          'firstName',
          'lastName',
          'rating',
          'country',
          'position',
          'email',
          'company'
        ]
      }
    },
    computed: {
      ...mapGetters(['getFormOpened', 'getCompanyDetail']),
      ...mapGetters(['getUserDetails', 'getAdminUser']),
      ...mapGetters(['getEvent', 'getEventList']),
      ...mapGetters(['getCompanyDetail', 'getCompanyListDetail']),
      ...mapGetters(['getLicenseDetail', 'getLicenseListDetail']),

      formData() {
        return this.formDataList;
      }
    },
    watch: {
      forms(forms) {
        this.setTableData(forms);
      },
    },
    methods: {
      ...mapActions(['setFormOpened', 'setUserDetails', 'setAdminUser']),
      ...mapActions(['setEvent', 'setEventList']),
      ...mapActions(['setCompanyDetail', 'setCompanyListDetail']),
      ...mapActions(['setLicenseDetail', 'setLicenseListDetail']),

      typeError(val, ref) {
        this.$Notice.warning({
          title: 'Zero is reserved for ' + val
        });
      },

      setTableData(forms) {
        this.items = forms;
        this.spinformShow = false;
      },
      getFormsData() {
        let localCompany = localStorage.getItem('selected_company');
        let localEvent = localStorage.getItem('selected_event');

        let company = JSON.parse(localStorage.getItem('companies'))
          .filter(a => a.companyName === localCompany || a.companyId === parseInt(localCompany))[0];

        let event = JSON.parse(localStorage.getItem('events'))
          .filter(a => a.eventName === localEvent || a.eventId === parseInt(localEvent))[0];

        if (company && event) {

          // Make a request to get all LeadForms and then filter to load the LeadForms attached to the selected company and event
          getForms(false, true, null).then(response => {
            this.items = [];
            this.formDataList = [];
            this.showFormTitle = false;
            this.showFormDesc = false;
            this.showAddress = false;
            this.showCity = false;
            this.showPhone = false;
            this.showJobTitle = false;
            this.showRating = false;

            ///getting event
            let eventId = 0;
            if (event) {
              eventId = event.eventId;
            }

            //adding data
            let result = [];
            response.data.filter(x => x.isLeadForm == true).map(item => {
              result.push(item);
            });

            //filter
            result = result.filter(x => x.eventId == eventId);
            let companyId = company.companyId;

            //load all forms attached to Company -- if company logged in
            if (localStorage.getItem('role') != 'admin') {
              result = result.filter(x => x.companyId == null || x.companyId == companyId);
            } else { //load all forms based on Company Drop Down -- if admin logged in
              //load all forms attached to Company
              if (companyId && companyId != "0") {
                result = result.filter(x => x.companyId == null || x.companyId == companyId);
              } else {
                result = result.filter(x => x.companyId == null);
              }
            }

            //finalize
            result.sort((a, b) => (a.isActive < b.isActive) ? 1 : ((b.isActive < a.isActive) ? -1 : 0));
            result.map(item => {
              this.items.push(item);
            });

            this.spinformShow = false;
            this.showPager = false;
            this.historyData = this.items;
            this.dataCount = this.items.length;
            this.allQuestions = [];
            this.historyData.map(i => {
              if (i.questions) {
                let data_ = {
                  formId: i.formId,
                  formName: i.title,
                  questions: i.questions
                };
                this.allQuestions.push(data_);
              }
            });
            if (this.historyData.length < this.pageSize) {
              this.items = this.historyData;
            } else {
              this.items = this.historyData.slice(0, this.pageSize);
            }
            if (this.items.length > 0) {
              this.showPager = true;
            }
          });
        } else {
          this.items = [];
          this.spinformShow = false;
          this.showPager = false;
        }
      },
      changePageSize(size) {
        this.pageSize = size;
        this.changeSelectedPage(1);
      },
      changeSelectedPage(index) {
        let _start = (index - 1) * this.pageSize;
        let _end = index * this.pageSize;
        this.items = this.historyData.slice(_start, _end);
      },
      showSpin() {
        this.spinformShow = true
      },
      add_Form(data) {
        this.items.push(data)
      },
      update_Form(id, data) {
        let itemIndex = this.items.map(i => {
          return i.formId;
        }).indexOf(id)
        this.items.splice(itemIndex, 1, data);
      },
      view_Form(id, data) {
        let itemIndex = this.items.map(i => {
          return i.formId;
        }).indexOf(id)
        this.items.splice(itemIndex, 1, data);
      },
      remove_Form(index) {
        deleteForm(this.items[index].formId, true).then(response => {
          if (response.data == 'Form cannot be deleted because it is being used!') {
            this.$Message.error('Form cannot be deleted because it is being used!');
          } else {
            this.items.splice(index, 1);
            this.$Message.success('Form successfully deleted!');
          }
        }).catch(error => {
          this.$Message.error('Failed deleting form');
        })
      },
      setChoiceStatus(newData, action) {

        if (newData.questions) {
          newData.questions.map((q, i) => {
            q.canAddChoices = false;
            q.status = true;

            if (q.choices) {
              q.choices.map(c => {
                c.questionId = q.questionId;
                c.status = false;
                if (action != 'view') {
                  if (q.type != 'text' && q.inputType != 'leadRating' && q.title.toLowerCase() != 'id') {
                    c.status = true;
                  }
                }
              })
            }

            if (action != 'view') {
              if (q.type != 'text' && q.inputType != 'leadRating' && q.title.toLowerCase() != 'id'
                && q.inputType.toLowerCase() != 'country') {
                q.canAddChoices = true;
              }
            }
          })
        }
        return newData;
      },

      editForm(params) {
        this.setFormOpened(true);
        localStorage.setItem('formOpened', true);
        this.addedForm = false;
        this.showRating = false;
        this.showAddress = false;
        this.showCity = false;
        this.showPhone = false;
        this.showJobTitle = false;
        this.showFormTitle = false;
        this.showFormDesc = false;
        this.items = [];
        this.formDataList = [];

        if (params) {
          this.form.title = params.title;
          this.form.formId = params.formId;
          this.form.companyId = params.companyId;
          this.form.eventId = params.eventId;
          this.form.desc = params.desc;
          this.form.order = params.order;
          this.form.isLeadForm = params.isLeadForm;
          this.form.isSurveyForm = params.isSurveyForm;
          this.form.isActive = params.isActive;
          this.form.LeadFormIds = params.leadFormIds;
          this.form.SurveyFormIds = params.surveyFormIds;

          if (this.userRole != 'admin') {
            let companyId = null;
            let companyObj = JSON.parse(localStorage.getItem('companies'))
              .filter(a => a.companyName == localStorage.getItem('selected_company'));
            if (companyObj) {
              if (companyObj.length > 0) {
                companyId = companyObj[0].companyId;
              }
            }

            getSubFormByIds(companyId, params.eventId, params.formId)
              .then(response => {
                let questions = response.data.questions;
                this.subFormId = response.data.subFormId;
                params.questions = questions;
                if (params.questions) {
                  //filter unique
                  params.questions = params.questions.filter((val, index, item) => item.indexOf(val) === index);
                  //loop thru
                  params.questions.map((q, ix) => {
                    q.status = true;
                    q.canDelete = true;
                    if (q.title.toLowerCase() === 'id') {
                      q.order = -1;
                      q.canDelete = false;
                      q.status = false;
                    }
                    if (q.fieldCode.indexOf('barcode') > -1 || q.fieldCode.indexOf('codebarre') > -1
                      || q.title.indexOf('barcode') > -1 || q.title.indexOf('codebarre') > -1) {
                      q.order = -1;
                    }
                    if (q.fieldCode === 'leadRating') {
                      this.showRating = true;
                    }
                    if (q.fieldCode === 'address') {
                      this.showAddress = true;
                    }
                    if (q.fieldCode === 'city') {
                      this.showCity = true;
                    }
                    if (q.fieldCode === 'phoneNumber') {
                      this.showPhone = true;
                    }
                    if (q.fieldCode === 'jobTitle') {
                      this.showJobTitle = true;
                    }
                    this.formDataList.push({
                      allowOther: q.allowOther,
                      choices: q.choices,
                      fieldCode: q.fieldCode,
                      headerTag: q.headerTag,
                      formId: params.formId,
                      inputType: q.inputType,
                      questionId: q.questionId,
                      order: q.order,
                      label: q.title,
                      type: q.type,
                      hide: !q.visible,
                      optional: q.optional,
                      canDelete: q.canDelete,
                      status: q.status,
                    });
                  });
                }
                //order questions
                this.formDataList = this.formDataList
                  .filter(a => a.status !== false)
                  .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));

                //results
                let list = this.formDataList;
                this.formDataList = [];
                this.form.questions = [];
                list.map((item, i) => {
                  item.order = i;
                  this.formDataList.push(item);
                  this.form.questions.push(item);
                });
              })
              .catch(error => {
                console.log('Get SubForm By Ids Failed - ' + error);
              });
          } else {
            if (params.questions) {

              //filter unique
              params.questions = params.questions.filter((val, index, item) => item.indexOf(val) === index);

              //loop thru
              params.questions.map((q, ix) => {
                q.canDelete = true;
                q.status = true;

                if (q.title.toLowerCase() === 'id') {
                  q.order = -1;
                  q.status = false;
                  q.canDelete = false;
                }
                if (q.fieldCode.indexOf('barcode') > -1 || q.fieldCode.indexOf('codebarre') > -1
                  || q.title.indexOf('barcode') > -1 || q.title.indexOf('codebarre') > -1) {
                  q.order = -1;
                  //q.canDelete = false;
                }
                if (q.fieldCode === 'leadRating') {
                  this.showRating = true;
                }
                if (q.fieldCode === 'address') {
                  this.showAddress = true;
                }
                if (q.fieldCode === 'city') {
                  this.showCity = true;
                }
                if (q.fieldCode === 'phoneNumber') {
                  this.showPhone = true;
                }
                if (q.fieldCode === 'jobTitle') {
                  this.showJobTitle = true;
                }

                this.formDataList.push({
                  allowOther: q.allowOther,
                  choices: q.choices,
                  fieldCode: q.fieldCode,
                  headerTag: q.headerTag ? q.headerTag : q.fieldCode,
                  formId: params.formId,
                  inputType: q.inputType,
                  questionId: q.questionId,
                  order: q.order,
                  label: q.title,
                  type: q.type,
                  hide: !q.visible,
                  status: q.status,
                  optional: q.optional,
                  canDelete: q.canDelete,
                });
              });
            }
            //order questions
            this.formDataList = this.formDataList
              .filter(a => a.status !== false)
              .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));

            //results
            let list = this.formDataList;
            this.formDataList = [];
            this.form.questions = [];
            list.map((item, i) => {
              item.order = i;
              if (item.fieldCode === 'barcode' || item.fieldCode === 'codebarre') {
                item.hide = true;
                console.log(item)
              }
              this.formDataList.push(item);
              this.form.questions.push(item);
            });
          }
        }
        this.spinformShow = false;
        return this.formDataList;
      },
      saveUpdatedForm() {
        this.showFormTitle = false;
        this.showFormDesc = false;
        this.showAddress = false;
        this.showCity = false;
        this.showPhone = false;
        this.showJobTitle = false;
        this.showRating = false;

        let list = [];
        this.formDataList.map((q) => {
          let fieldCode = q.fieldCode;
          if (q.fieldCode == 'other') {
            fieldCode = q.label.replace(/\s+/g, '-').toLowerCase();
          }
          list.push({
            questionId: q.questionId,
            formId: q.formId,
            title: q.label,
            type: q.type,
            inputType: q.inputType,
            fieldCode: fieldCode,
            headerTag: q.headerTag,
            visible: !q.hide,
            optional: q.optional,
            allowOther: q.allowOther,
            order: q.order,
            choices: q.choices
          });
        });
        this.form.questions = [];
        this.form.questions = list;

        const data = Object.assign({}, this.form);
        delete data['_index'];
        delete data['_rowKey'];

        updateForm(this.form.formId, data).then(response => {
          this.$emit('updateForm', this.form.formId, data);
          this.$Message.success('Form successfully update!');
          this.setFormOpened(false);
          localStorage.setItem('formOpened', false);
          bus.$emit('getActiveLink', 'GlobalAdministration');
        }).catch(error => {
          this.$Message.error('Failed updating form ' + error);
        });
      },
      saveNewForm() {
        this.showFormTitle = false;
        this.showFormDesc = false;
        this.showAddress = false;
        this.showCity = false;
        this.showPhone = false;
        this.showJobTitle = false;
        this.showRating = false;


        let list = [];
        this.formDataList.map((q) => {
          let fieldCode = q.fieldCode;
          if (q.fieldCode == 'other') {
            fieldCode = q.label.replace(/\s+/g, '-').toLowerCase();
          }
          list.push({
            questionId: q.questionId,
            formId: q.formId,
            title: q.label,
            type: q.type,
            inputType: q.inputType,
            fieldCode: fieldCode,
            headerTag: q.headerTag,
            visible: !q.hide,
            optional: q.optional,
            allowOther: q.allowOther,
            order: q.order,
            choices: q.choices
          });
        });
        this.form.questions = [];
        this.form.questions = list;

        if (localStorage.getItem('role') != 'admin') {
          data['companyId'] = parseInt(localStorage.getItem('companyId'));
        }

        const data = Object.assign({}, this.form);
        delete data['_index'];
        delete data['_rowKey'];

        var formToDeactivate = {
          formId: null,
          title: null,
          desc: null,
          companyId: null,
          eventId: null,
          order: null,
          isLeadForm: null,
          isSurveyForm: null,
          isActive: null,
          questions: null
        };

        if (this.form.isActive === true) {
          var eventId = localStorage.getItem('selected_event');
          getLeadFormByEvent(eventId).then(leadFrm => {
            if (leadFrm.data !== '' && leadFrm.data != null) {
              formToDeactivate.formId = leadFrm.data.formId;
              formToDeactivate.title = leadFrm.data.title;
              formToDeactivate.desc = leadFrm.data.desc;
              formToDeactivate.companyId = leadFrm.data.companyId;
              formToDeactivate.eventId = leadFrm.data.eventId;
              formToDeactivate.order = leadFrm.data.order;
              formToDeactivate.isLeadForm = leadFrm.data.isLeadForm;
              formToDeactivate.isSurveyForm = leadFrm.data.isSurveyForm;
              formToDeactivate.isActive = false;
              formToDeactivate.questions = leadFrm.questions;
              updateForm(formToDeactivate.formId, formToDeactivate);
            }
            addForm(data).then(response => {
              this.$emit('addForm', this.form.formId, data);
              this.$Message.success('Form successfully Created!');

              this.setFormOpened(false);
              localStorage.setItem('formOpened', false);
              bus.$emit('getActiveLink', 'GlobalAdministration');
            }).catch(error => {
              this.$Message.error('Failed adding form ' + error);
            });
          });
        } 
        else {
          addForm(data).then(response => {
            this.$emit('addForm', this.form.formId, data);
            this.$Message.success('Form successfully Created!');

            this.setFormOpened(false);
            localStorage.setItem('formOpened', false);
            bus.$emit('getActiveLink', 'GlobalAdministration');
          }).catch(error => {
            this.$Message.error('Failed adding form ' + error);
          });

        }
      },
      goBack() {
        this.setFormOpened(false);
        localStorage.setItem('formOpened', false);
        bus.$emit('getActiveLink', 'GlobalAdministration');
      },
      goBackToForms() {
        this.getFormsData();
        this.setFormOpened(false);
        localStorage.setItem('formOpened', false);
      },
      handleReset() {
        let self = this;
        Object.keys(this.formDataList).forEach(function (key, i) {
          self.formDataList[key] = '';
        });
      },

      remove_Question(index) {
        let fieldCode = this.formDataList[index].fieldCode;
        if (fieldCode == 'address') {
          this.showAddress = false;
        }
        if (fieldCode == 'city') {
          this.showCity = false;
        }
        if (fieldCode == 'phoneNumber') {
          this.showPhone = false;
        }
        if (fieldCode == 'jobTitle') {
          this.showJobTitle = false;
        }
        if (fieldCode == 'leadRating') {
          this.showRating = false;
        }
        this.formDataList.splice(index, 1);
        this.$Message.success('Question successfully deleted!');
      },
      getQuestionTitle(question) {
        let title = "";
        if (question.type === 'text') {
          if (question.inputType == 'email') {
            title = 'Email';
          }
          if (question.inputType === 'phoneNumber') {
            title = 'Phone';
          }
          if (question.inputType === 'text') {
            title = 'String';
          }
          if (question.inputType === 'date') {
            title = 'Date';
          }
          if (question.inputType === 'country') {
            title = 'Country';
          }
        }
        if (question.type === 'textArea') {
          title = 'Text Area';
        }
        if (question.type === 'buttonGroup') {
          title = 'Button Group';
        }
        if (question.type === 'checkbox') {
          title = 'Multiple Choice';
        }
        if (question.type === 'leadRating') {
          title = 'Lead Rating';
        }
        if (question.type === 'radioList') {
          title = 'Single Choice';
        }
        if (question.type === 'photo') {
          title = 'Photo';
        }
        if (question.type === 'QRCode') {
          title = 'Scan';
        }
        return title;
      },
      getQuestionIcon(question) {
        let iconType = "";
        let type = question.inputType.toLowerCase();

        if (type === 'email') {
          iconType = 'ios-mail-outline';
        }
        if (type === 'phonenumber') {
          iconType = 'ios-call-outline';
        }
        if (type === 'text') {
          iconType = 'ios-menu-outline';
        }
        if (type === 'date') {
          iconType = 'ios-calendar-outline';
        }
        if (type === 'textarea') {
          iconType = 'ios-menu-outline';
        }
        if (type === 'multichoice') {
          iconType = 'ios-checkbox-outline';
        }
        if (type === 'leadrating') {
          iconType = 'ios-star-outline';
        }
        if (type === 'singlechoice') {
          iconType = 'ios-radio-button-on';
        }
        if (type === 'country') {
          iconType = 'ios-flag-outline';
        }
        if (type === 'photo') {
          iconType = 'ios-image-outline';
        }
        if (type === 'scan') {
          iconType = 'ios-qr-scanner';
        }
        return iconType;
      },
      toggleFormName() {
        this.showFormTitle = !this.showFormTitle;
      },
      toggleFormDesc() {
        this.showFormDesc = !this.showFormDesc;
      },

      addAddress() {
        this.showAddress = true;
        let data = {
          allowOther: false,
          choices: null,
          fieldCode: 'address',
          headerTag: 'address',
          formId: this.form.formId,
          inputType: 'text',
          questionId: this.getTimeStamp() + this.formDataList.length,
          order: this.formDataList.length + 1,
          label: 'Address',
          type: 'text',
          hide: false,
          optional: true,
        };
        this.formDataList.push(data);
      },
      addCity() {
        this.showCity = true;
        let data = {
          allowOther: false,
          choices: null,
          fieldCode: 'city',
          headerTag: 'city',
          formId: this.form.formId,
          inputType: 'text',
          questionId: this.getTimeStamp() + this.formDataList.length,
          order: this.formDataList.length + 1,
          label: 'City',
          type: 'text',
          hide: false,
          optional: true,
        };
        this.formDataList.push(data);
      },
      addPhone() {
        this.showPhone = true;
        let data = {
          allowOther: false,
          choices: null,
          fieldCode: 'phoneNumber',
          headerTag: 'phonenumber',
          formId: this.form.formId,
          inputType: 'text',
          questionId: this.getTimeStamp() + this.formDataList.length,
          order: this.formDataList.length + 1,
          label: 'Phone',
          type: 'text',
          hide: false,
          optional: true,
        };
        this.formDataList.push(data);
      },
      addJobTitle() {
        this.showJobTitle = true;
        let data = {
          allowOther: false,
          choices: null,
          fieldCode: 'jobTitle',
          headerTag: 'jobtitle',
          formId: this.form.formId,
          inputType: 'text',
          questionId: this.getTimeStamp() + this.formDataList.length,
          order: this.formDataList.length + 1,
          label: 'Job Title',
          type: 'text',
          hide: false,
          optional: true,
        };
        this.formDataList.push(data);
      },
      addRating() {
        this.showRating = true;
        let id = this.getTimeStamp() + this.formDataList.length;
        let data = {
          allowOther: false,
          choices: [
            {
              label: 'HOT',
              actionOnSync: '',
              choiceId: id + "0",
              order: 0,
              questionId: id,
              status: 1
            },
            {
              label: 'WARM',
              actionOnSync: '',
              choiceId: id + "1",
              order: 1,
              questionId: id,
              status: 1
            },
            {
              label: 'COLD',
              actionOnSync: '',
              choiceId: id + "2",
              order: 2,
              questionId: id,
              status: 1
            }
          ],
          fieldCode: 'leadRating',
          headerTag: 'leadrating',
          formId: this.form.formId,
          inputType: 'leadRating',
          questionId: this.getTimeStamp() + this.formDataList.length,
          order: this.formDataList.length + 1,
          label: 'Lead Rating',
          type: 'leadRating',
          hide: false,
          optional: true,
        };
        this.formDataList.push(data);
      },
      addOther() {
        let data = {
          allowOther: false,
          choices: null,
          fieldCode: 'other',
          headerTag: 'other-' + (this.getTimeStamp() + this.formDataList.length).toString(),
          formId: this.form.formId,
          inputType: 'text',
          questionId: this.getTimeStamp() + this.formDataList.length,
          order: this.formDataList.length + 1,
          label: 'Other',
          type: 'text',
          hide: false,
          optional: true,
        };
        this.formDataList.push(data);
      },
      getTimeStamp() {
        let dt = Math.floor(Math.random() * Math.floor(4000000));
        return dt;
      },
      getRoutedForm(event) { // This function is called when the user is redirected from the Global Administration page after he clicked on the cog icon
        const self = this;
        self.addedForm = false;
        self.spinformShow = true;
        self.showFormTitle = true;
        self.showFormDesc = true;
        self.showAddress = false;
        self.showCity = false;
        self.showPhone = false;
        self.showJobTitle = false;
        self.showRating = false;
        self.items = [];
        self.formDataList = [];
        self.form = {};

        //create questions from participantForm inside Event
        let questions = [];
        if (event.participantForm) {
          if (JSON.parse(event.participantForm)) {
            Object.keys(JSON.parse(event.participantForm)).forEach(function (key, i) {
              let fieldCode = JSON.parse(event.participantForm)[key].replace(/\s+/g, '-').toLowerCase();
              if (fieldCode === 'codebarre') {
                fieldCode = 'barcode';
              }
              let headerTag = JSON.parse(event.participantForm)[key].replace(/\s+/g, '').toLowerCase();

              questions.push({
                questionId: self.getTimeStamp(),
                order: self.getTimeStamp(),
                formId: self.form.formId,
                title: JSON.parse(event.participantForm)[key],
                visible: true,
                optional: true,
                allowOther: false,
                fieldCode: fieldCode,
                headerTag: headerTag,
                inputType: 'text',
                type: 'text',
                choices: null,
                canDelete: false,
                status: true
              });

            });
          }
        }

        getForms(false, true, null).then(response => {
          // response.data has all events regardless whether companyId is null or not
          let eventId = event.eventId;
          // Filtering of response.data to only keep LeadForms of the company and event chosen by the user
          let result = response.data
            .filter(x => x.companyId == null)
            .filter(x => x.isLeadForm == true)
            .filter(x => x.eventId == eventId)
            .sort((a, b) => (a.isActive < b.isActive) ? 1 : ((b.isActive < a.isActive) ? -1 : 0));
          let items = result;

          self.form.eventId = event.eventId;
          self.form.order = 0;
          self.form.isLeadForm = true;
          self.form.isSurveyForm = false;
          self.form.isActive = true;

          if (items.length > 0) { // A LeadForm already exists for the company and event chosen by the user
            self.form.title = items[0].title;
            self.form.desc = items[0].desc;
            self.form.formId = items[0].formId;
            self.form.companyId = items[0].companyId;
            self.form.questions = items[0].questions;
          } 
          else { // No LeadForm linked to the company and event chosen by the user, a new LeadForm have to be created
            self.addedForm = true;
            self.form.title = 'Generated Form for Event - ' + event.eventName;
            self.form.desc = 'Generated Form for Event - ' + event.eventName;
            self.form.formId = 0;
            self.form.companyId = null;
            self.form.questions = [];
          }

          //match
          let formDataList = [];
          if (self.form.questions) {
            self.form.questions
              .map((q, ix) => {
                q.canDelete = true;
                q.status = true;
                let fieldCode = q.fieldCode.toLowerCase();
                let title = q.title.toLowerCase();

                if (fieldCode.indexOf('barcode') > -1 || fieldCode.indexOf('codebarre') > -1
                  || title.indexOf('barcode') > -1 || title.indexOf('codebarre') > -1) {
                  q.order = -1;
                }
                if (fieldCode.indexOf('id') > -1 || title.indexOf('id') > -1) {
                  q.order = -1;
                  q.canDelete = false;
                  q.status = false;
                  q.fieldCode = 'id';
                }
                if (q.fieldCode == 'leadRating') {
                  self.showRating = true;
                }
                if (q.fieldCode == 'address') {
                  self.showAddress = true;
                }
                if (q.fieldCode == 'city') {
                  self.showCity = true;
                }
                if (q.fieldCode == 'phoneNumber') {
                  self.showPhone = true;
                }
                if (q.fieldCode == 'jobTitle') {
                  self.showJobTitle = true;
                }
              });

            self.form.questions = self.form.questions
              .filter(a => a.status !== false)
              .sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0))
              .map((q, ix) => {
                formDataList.push({
                  allowOther: q.allowOther,
                  choices: q.choices,
                  fieldCode: q.fieldCode,
                  headerTag: !q.headerTag ? q.title.toLowerCase() : q.headerTag,
                  formId: q.formId,
                  inputType: q.inputType,
                  questionId: q.questionId,
                  order: q.order,
                  label: q.title,
                  type: q.type,
                  hide: !q.visible,
                  optional: q.optional,
                  canDelete: q.canDelete,
                  status: q.status
                });
                if (q.headerTag === 'barcode' || q.headerTag === 'codebarre') {
                  formDataList[ix].hide = true;
                }
              });
          }

          //append new questions to FormQuestions
          if (questions.length > 0) {
            questions.map((q, index) => {
              let id = Math.floor(Math.random() * Math.floor(4000000));
              formDataList.push({
                allowOther: q.allowOther,
                choices: q.choices,
                fieldCode: q.fieldCode,
                headerTag: q.headerTag,
                formId: q.formId,
                inputType: q.inputType,
                questionId: id + index,
                order: id + index,
                label: q.title,
                type: q.type,
                hide: !q.visible,
                optional: q.optional,
                canDelete: false,
                status: q.status
              });
              if (q.headerTag === 'barcode' || q.headerTag === 'codebarre') {
                formDataList[index].hide = true;
              }
            });
          }

          //sorting
          //formDataList.sort((a, b) => (a.order > b.order) ? 1 : ((b.order > a.order) ? -1 : 0));

          //filtering
          formDataList = formDataList.filter((val, index, item) => item.indexOf(val) === index);
          let list = formDataList.filter((item, index, self) =>
            index === self.findIndex((t) => (
              t.headerTag === item.headerTag
            ))
          );

          //results
          self.formDataList = [];
          self.form.questions = [];
          list.map((item, i) => {
            item.order = i;
            self.formDataList.push(item);
            self.form.questions.push(item);
          });
          self.spinformShow = false;
        });
      }
    },
    created() {
      this.spinformShow = true;
      if (this.getFormOpened == false) {
        this.getFormsData();
      }
    },
    destroyed() {
      this.setFormOpened(false);
      localStorage.setItem('formOpened', false);
    },
    mounted() {
      const self = this;
      self.spinformShow = true;

      if (localStorage.getItem('formOpened') == false) {
        self.getFormsData();
      }
      bus.$on('changeForm', (eventName, companyName) => {
        self.setFormOpened(false);
        localStorage.setItem('formOpened', false);
        self.spinformShow = true;
        self.getFormsData();
      });
      bus.$on('syncLeadForm', (event) => {
        self.spinformShow = true;
        self.getRoutedForm(event);
      });

    }
  }
</script>
<style scoped>

  .ivu-card-custom {
    overflow: auto;
    height: auto;
  }

  .ivu-table table tbody tr td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table-wrapper:not(.show-borders) .ivu-table table tbody tr:last-of-type td {
    vertical-align: top;
    padding-top: 5px;
  }

  .ivu-table td {
    height: 80px;
  }

  .ivu-table .table-cell-custom {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
  }

  .ivu-table-cell .ivu-poptip,
  .ivu-table-cell .ivu-table-sort {
    position: absolute;
    right: auto;
  }

  .ivu-table-cell td, .ivu-table-cell th {
    border: 0;
    height: 20px;
    line-height: 1;
  }

  .selectInput {

  }

  .selectInput .ivu-select-input {
    background-color: #c6e5fd;
  }

  .btnAdds {
    background-color: #004f6e;
    color: #fff;
  }

  .btnAdds:hover {
    background-color: #ffffff;
    color: #004f6e;
  }
</style>



// WEBPACK FOOTER //
// src/components/b_MyLeadForms/forms.vue